import { render, staticRenderFns } from "./OurFees.vue?vue&type=template&id=4bd308f6&scoped=true&"
import script from "./OurFees.vue?vue&type=script&lang=ts&"
export * from "./OurFees.vue?vue&type=script&lang=ts&"
import style0 from "./OurFees.vue?vue&type=style&index=0&id=4bd308f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd308f6",
  null
  
)

export default component.exports